export class AdminWorkspace {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": "tobedefined"
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "eonAccountId",
            "baseName": "eonAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "cloud",
            "baseName": "cloud",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataplaneClusterType",
            "baseName": "dataplaneClusterType",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataplaneClusterName",
            "baseName": "dataplaneClusterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataplaneClusterApiEndpoint",
            "baseName": "dataplaneClusterApiEndpoint",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataplaneClusterCredentialsRef",
            "baseName": "dataplaneClusterCredentialsRef",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonDomainName",
            "baseName": "eonDomainName",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataplaneProxyUrl",
            "baseName": "dataplaneProxyUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "baseImageUrl",
            "baseName": "baseImageUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "gkeSparkSaEmail",
            "baseName": "gkeSparkSaEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "awsDataplaneAccountId",
            "baseName": "awsDataplaneAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcId",
            "baseName": "vpcId",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcCidr",
            "baseName": "vpcCidr",
            "type": "string",
            "format": ""
        },
        {
            "name": "availabilityZoneIds",
            "baseName": "availabilityZoneIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "workloadSubnetCidrs",
            "baseName": "workloadSubnetCidrs",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "WorkspaceStatus",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return AdminWorkspace.attributeTypeMap;
    }
    constructor() {
    }
}
